import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'appointments';
let loaded = loadState(STORE_KEY) || [];
const state = {
	showCreateAppointment: false,
	myAppointments: [],
	intermediaryAppointments: [],
	selectedAppointment: null,
};

const mutations = {
	SET_CREATE_APPOINTMENT(state, bool) {
		state.showCreateAppointment = bool;
	},
	SET_MY_APPOINTMENTS(state, data) {
		state.myAppointments = data;
	},
	SET_INTERMEDIARY_APPOINTMENTS(state, data) {
		state.intermediaryAppointments = data;
	},
	SET_SELECTED_APPOINTMENT(state, data) {
		state.selectedAppointment = data;
	},
};

const actions = {
	setShowCreateAppointments({ commit }, bool) {
		commit('SET_CREATE_APPOINTMENT', bool);
	},
	setMyAppointments({ commit }, data) {
		commit('SET_MY_APPOINTMENTS', data);
	},
	setIntermediaryAppointments({ commit }, data) {
		commit('SET_INTERMEDIARY_APPOINTMENTS', data);
	},
	setSelectedAppointment({ commit }, data) {
		commit('SET_SELECTED_APPOINTMENT', data);
		saveState(STORE_KEY, state);
	},
};

const getters = {
	showCreateAppointment: (state) => state.showCreateAppointment,
	showMyAppointments: (state) => state.myAppointments,
	showIntermediaryAppointments: (state) => state.intermediaryAppointments,
	showSelectedAppointment: (state) => state.selectedAppointment,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
